import Axios from "../utils/tms-axios/tms-axios";

export const PagaPassServices = {
  createPagaPass: async (body) => {
    const resp = await Axios.post(`em/paga-pass`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getPagaPasses: async () => {
    const resp = await Axios.get(`em/paga-pass`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  updatePagaPass: async (id, body) => {
    const resp = await Axios.patch(`em/paga-pass/${id}`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deletePagaPass: async (id) => {
    const resp = await Axios.delete(`em/paga-pass/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  scanPagaPass: async (id) => {
    const resp = await Axios.get(`em/paga-pass-scan/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  createPagaPassCounter: async (body) => {
    const resp = await Axios.post(`em/paga-pass-counter/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getPagaPassCounters: async () => {
    const resp = await Axios.get(`em/paga-pass-counter/all`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deletePagaPassCounter: async (id) => {
    const resp = await Axios.delete(`em/paga-pass-counter/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getPagaPassLogs: async (fromDate, toDate, page, limit, counterId) => {
    let url = `em/paga-pass/scan/logs?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`;
    if (counterId) {
      url = url + `&counterId=${counterId}`;
    }
    const resp = await Axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};
